import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreContainerComponent } from "../app/core/core-container/core-container.component";
import { HeaderComponent } from "../app/core/header/header.component";
import { MenuComponent } from "../app/core/menu/menu.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../app/shared-module/shared/shared.module";
import {
  DeviceComponent,
  Device_calibration,
  Device_communication,
} from "./device/device.component";
import { MatTableExporterModule } from "mat-table-exporter";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { SliderComponent } from "./slider/slider.component";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { PreferenceComponent } from "./preference/preference.component";
import { MatSelectCountryModule } from "@angular-material-extensions/select-country";
import { DriverComponent } from "./driver/driver.component";
import { TestComponent } from "./test/test.component";
import { CdkTreeModule } from "@angular/cdk/tree";

// Import timeseries

import { FormsModule } from "@angular/forms";
import {
  EditDriver,
  AddDriver,
  AddDriveruser,
  EditDriveruser,
} from "./driver/driver.component";

import { Test2Component } from "./test2/test2.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatBadgeModule } from "@angular/material/badge";
import {
  VehicleComponent,
  AddVehicule,
  EditVehicule,
  EditVehiculeuser,
} from "./vehicle/vehicle.component";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDividerModule } from "@angular/material/divider";
import { NgCircleProgressModule } from "ng-circle-progress";

import { UserComponent, EditUser } from "./user/user.component";

import { MatRadioModule } from "@angular/material/radio";
import {
  FormatTime,
  MaxRangeDirective,
  UserVehiculeComponent,
} from "./user-side/user-vehicle/user-vehicule/user-vehicule.component";
import { UserCoreContainerComponent } from "./user-side/user-core/user-core-container/user-core-container.component";
import { UserCoreHeaderComponent } from "./user-side/user-core/user-core-header/user-core-header.component";
import { UserCoreFooterComponent } from "./user-side/user-core/user-core-footer/user-core-footer.component";
import { UserCoreMenuComponent } from "./user-side/user-core/user-core-menu/user-core-menu.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgApexchartsModule } from "ng-apexcharts";
import {
  AddCompanyUser,
  CompanyuserComponent,
  UpdateCompanyUser,
} from "./company/companyuser/companyuser.component";
import {
  AddCompanyPartner,
  CompanypartnerComponent,
  UpdateCompanyPartner,
} from "./company/companypartner/companypartner.component";
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { ErrorInterceptor, JwtInterceptor } from "./_helpers";
import { LoginComponent } from "./login";
import {
  Chartalarm,
  DialogAddAlarm,
  DialogEditAlarm,
  Table_contact,
  UserAlarmEventsComponent,
} from "./user-side/user-alarm-events/user-alarm-events.component";
import {
  DialogAddAlarmAcc,
  DialogEditAlarmAcc,
  UserAlarmAccidentComponent,
} from "./user-side/user-alarm-accident/user-alarm-accident.component";
import {
  PdfDomComponent,
  ReportComponent,
} from "./user-side/report/report.component";
import { MatToolbarModule } from "@angular/material/toolbar";

import { MdePopoverModule } from "@material-extended/mde";
import {
  DialogAddplanrep,
  DialogEditplanrep,
  PlannificationReportComponent,
  Table_contact_plan,
} from "./user-side/plannification-report/plannification-report.component";
import {
  AddFavorisReportComponent,
  DialogEditFavrep,
} from "./user-side/add-favoris-report/add-favoris-report.component";
import { ReportHistoryComponent } from "./user-side/report-history/report-history.component";
import { MatSliderModule } from "@angular/material/slider";
import { UserVehiculeDetailsContainerComponent } from "./user-side/user-vehicle/user-vehicule-details/user-vehicule-details-container/user-vehicule-details-container.component";
import { UserVehiculeDetailsEventsComponent } from "./user-side/user-vehicle/user-vehicule-details/user-vehicule-details-events/user-vehicule-details-events.component";
import { UserVehiculeDetailsScoresComponent } from "./user-side/user-vehicle/user-vehicule-details/user-vehicule-details-scores/user-vehicule-details-scores.component";
import {
  MapDetailCrash,
  UserVehiculeDetComponent,
} from "./user-side/user-vehicle/user-vehicule-details/user-vehicule-det/user-vehicule-det.component";
import { ChartsModule } from "ng2-charts";
import { NgChartjsModule } from "ng-chartjs";
import { AgmCoreModule } from "@agm/core";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { ProfilComponent } from "./profil/profil.component";
import {
  UserAlarmComponent,
  DialogAddAlarmAccident,
  DialogEditAlarmAccident,
  UserAlarmEventsListeComponent,
  DialogAddAlarmEv,
  DialogEditAlarmEv,
} from "./user-side/user-alarm/user-alarm.component";
import { UserConducteurComponent } from "./user-side/user-conducteur/user-conducteur/user-conducteur.component";
import { UserConducteurDetailsComponent } from "./user-side/user-conducteur/user-conducteur-details/user-conducteur-details.component";
import { UserConducteurTrajetComponent } from "./user-side/user-conducteur/user-conducteur-trajet/user-conducteur-trajet.component";
import { NgxSpinnerModule } from "ngx-spinner";

import { AgmJsMarkerClustererModule } from "@agm/js-marker-clusterer";
// import {
//   ZoomControlOptions,
//   ControlPosition,
//   MapTypeControlOptions,
//   FullscreenControlOptions,
// } from "@agm/core/services/google-maps-types";
import { EventsComponent } from "./user-side/events/events/events.component";
import { EventsDetailsComponent } from "./user-side/events/events-details/events-details.component";
import { ContactComponent } from "./user-side/contact/contact.component";
import { HistoriqueAlarmComponent } from "./user-side/historique-alarm/historique-alarm.component";
import {
  NgbPaginationModule,
  NgbAlertModule,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";

import { GestureConfig, OwlTimerModule } from "owl-ng";
import { OwlClockModule } from "owl-ng";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { OwlDateTimeIntl } from "ng-pick-datetime";
import { GaugeChartModule } from "angular-gauge-chart";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { ErrorPageComponent } from "./error-page/error-page.component";
import { DateAgoPipe } from "./pipes/date-ago.pipe";
import { AgmDirectionModule } from "agm-direction";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { FileSaverModule } from "ngx-filesaver";

import { SimpleNotificationsModule } from "angular2-notifications";
import { RouterModule } from "@angular/router";
import { GuidedTourModule, GuidedTourService } from "ngx-guided-tour";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { PushNotificationsModule } from "ng-push-ivy";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { NewLoginComponent } from "./newComponents/new-login/new-login.component";
import { UnitsComponent } from "./shared/units/units.component";

@NgModule({
  declarations: [
    MaxRangeDirective,
    FormatTime,
    AppComponent,
    CoreContainerComponent,
    HeaderComponent,
    DashboardComponent,
    MenuComponent,
    DeviceComponent,
    SliderComponent,
    PreferenceComponent,
    DriverComponent,
    TestComponent,
    EditDriver,
    AddDriver,
    EditDriveruser,
    AddDriveruser,
    Test2Component,
    VehicleComponent,
    AddVehicule,
    EditVehicule,
    EditVehiculeuser,
    UserComponent,
    EditUser,
    UserVehiculeComponent,
    Device_communication,
    UserCoreContainerComponent,
    UserCoreHeaderComponent,
    UserCoreMenuComponent,
    UserCoreFooterComponent,
    Device_calibration,
    CompanyuserComponent,
    CompanypartnerComponent,
    LoginComponent,
    AddCompanyPartner,
    UpdateCompanyPartner,
    UserAlarmEventsComponent,
    DialogAddAlarm,
    DialogAddAlarmEv,
    DialogEditAlarmEv,
    DialogEditAlarm,
    Chartalarm,
    Table_contact,
    AddCompanyUser,
    UpdateCompanyUser,
    UserAlarmAccidentComponent,
    DialogEditAlarmAcc,
    DialogAddAlarmAcc,
    DialogAddAlarmAccident,
    DialogEditAlarmAccident,
    UserAlarmEventsListeComponent,
    ReportComponent,
    AddFavorisReportComponent,
    DialogEditFavrep,
    PlannificationReportComponent,
    DialogAddplanrep,
    DialogEditplanrep,
    Table_contact_plan,
    UnitsComponent,

    ReportHistoryComponent,

    UserVehiculeDetailsContainerComponent,
    UserVehiculeDetailsEventsComponent,
    UserVehiculeDetailsScoresComponent,
    UserVehiculeDetComponent,

    ReportHistoryComponent,
    ResetPasswordComponent,
    ProfilComponent,
    UserAlarmComponent,
    UserConducteurComponent,
    UserConducteurDetailsComponent,
    UserConducteurTrajetComponent,
    EventsComponent,
    EventsDetailsComponent,
    ContactComponent,
    HistoriqueAlarmComponent,
    ErrorPageComponent,
    DateAgoPipe,
    MapDetailCrash,
    PdfDomComponent,
    NewLoginComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    NgxMaterialTimepickerModule,
    SimpleNotificationsModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    MatCardModule,
    ClipboardModule,
    SharedModule,
    ChartsModule,
    MatTableExporterModule,
    HttpClientModule,
    CdkTreeModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
    MatSnackBarModule,
    MatSelectCountryModule,

    FormsModule,
    MatSidenavModule,
    MatBadgeModule,
    MatStepperModule,
    MatDialogModule,
    MatDividerModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,

      animationDuration: 300,
    }),
    MatRadioModule,
    MatExpansionModule,
    NgApexchartsModule,

    NgxChartsModule,

    GaugeChartModule,

    NgxQRCodeModule,
    MatSliderModule,
    NgChartjsModule,
    MatToolbarModule,
    MdePopoverModule,
    MatCardModule,
    NgxSpinnerModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBgYMINXPs5UtbU6UO_i9fc4KYNFCTb9Rs",
      libraries: ["places", "drawing", "geometry"],
      region: "MA",
    }),
    AgmJsMarkerClustererModule,

    NgbPaginationModule,
    NgbAlertModule,
    NgbModule,
    OwlTimerModule,
    OwlClockModule,
    NoopAnimationsModule,
    MatAutocompleteModule,
    AgmDirectionModule,
    GuidedTourModule,
    NgxSliderModule,
    RouterModule.forRoot([]),
    PushNotificationsModule,
    FileSaverModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: OwlDateTimeIntl,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "fill" },
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    GuidedTourService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "../assets/", ".json");
}
